import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./user-profile.module.css";
import { useContext, useState, useEffect } from "react";
import { UserIcon } from "../../../assets/user-icon";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { Favourites } from "../favourites/favourites";
import { BasketNavigation } from "../basket-navigation/basket-navigation";
export const UserProfile = ({ checkoutModal , shouldShowBasketIcon  })=>{
    const { logicStore , userStore  } = useContext(SharedUiHeaderV2Context);
    const [isDesktop, setIsDesktop] = useState(false);
    const { handleTrackEvent , isCheckoutModalVisible  } = logicStore;
    const { firstName , isLoggedIn  } = userStore;
    useEffect(()=>{
        if ("object" !== "undefined") {
            setIsDesktop((window === null || window === void 0 ? void 0 : window.innerWidth) >= 767);
        }
    });
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.userProfileWrapper,
        children: [
            /*#__PURE__*/ _jsxs("a", {
                className: styles.profileLink,
                href: "/my-profile",
                "aria-label": "my profile",
                onClick: ()=>{
                    handleTrackEvent({
                        name: "click",
                        category: "mega menu",
                        label: "my profile",
                        action: "button"
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.profileLinkText,
                        "data-dd-privacy": "mask",
                        children: firstName ? `Hi ${firstName}!` : "My Profile"
                    }),
                    /*#__PURE__*/ _jsx(UserIcon, {})
                ]
            }),
            isLoggedIn ? /*#__PURE__*/ _jsx(Favourites, {}) : null,
            isDesktop && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BasketNavigation, {
                        checkoutModalAvailable: !!checkoutModal,
                        shouldShowBasketIcon: shouldShowBasketIcon
                    }),
                    isCheckoutModalVisible && checkoutModal
                ]
            })
        ]
    });
};
